export default __webpack_public_path__ + "static/media/plate2.b9340997.png";